<template>
    <a-drawer
      :title="title"
      :visible="visible"
      :placement="'top'"
      @close="$emit('close')"
      :height="'100%'"
      :wrapClassName="'addClasses'"
    >
        <addProfessional :visible="showP" :tags="ProfessList" @close="closeProfess"></addProfessional>
        <addSchool :visible="showSchool" :tags="SchoolList" @close="closeSchool"></addSchool>
        <addBpid :visible="showBpid" :tags="BpidList" @close="closeBpid"></addBpid>
        <div class="content">
           <a-form
                :form="form"
                v-bind="formItemLayout"
            >
                <a-form-item label="上传封面图">
                    <a-upload
                        name="avatar"
                        list-type="picture-card"
                        :show-upload-list="false"
                        :customRequest="customRequest"
                        v-decorator="['fileImg',
                            { rules: [{ required: true, message: '请上传图片' }] },
                        ]"
                    >
                        <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
                        <div v-else>
                            <a-icon :type="loading ? 'loading' : 'plus'" style="font-size:30px;color:#dcdcdc"/>
                            <div>上传图片</div>
                        </div>
                    </a-upload>
                    <span>建议尺寸为123*123，大小不超过10M,格式为jpg</span>
                </a-form-item>
                <a-form-item label="课程包名称">
                    <a-input
                        v-decorator="['name', { initialValue: formData.name, rules: [{ required: true, message: '请输入课程包名称' }] }]"
                    />
                </a-form-item>
                <a-form-item label="简称">
                    <a-input
                        v-decorator="['short_name', { initialValue: formData.short_name, rules: [{ required: true, message: '请输入简称' }] }]"
                    />
                </a-form-item>
                <a-form-item label="标题">
                    <a-input
                        v-decorator="['title', { initialValue: formData.title, rules: [{ required: true, message: '请输入标题' }] }]"
                    />
                </a-form-item>
                <a-form-item label="标签">
                    <a-input
                        v-decorator="['tag', { initialValue: formData.tag, rules: [{ required: true, message: '请输入标签名称' }] }]"
                    />
                </a-form-item>
                <a-form-item label="分类">
                    <a-select v-if="options" v-decorator="['cate_id', { initialValue: formData.cate_id, rules: [{ required: true, message: '请选择标签' }] }]" @change="changeCate" class="mr10px" placeholder="请选择分类">
                        <a-select-option v-for="item in options" :key="item.id" :value="item.id">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="学校" v-if="this.form.getFieldValue('cate_id') == 41 || this.form.getFieldValue('cate_id') == 42" >
                    <div style="display:flex;align-items:center">
                        <a-select v-decorator="['school', { initialValue: formData.school, rules: [{ required: true, message: '请选择学校' }] }]" class="mr10px" placeholder="请选择学校">
                            <a-select-option v-for="item in SchoolList" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                        <a-icon type="plus-circle" class="csP fs18px" @click="showSchool = true"/>
                    </div>
                </a-form-item>
                <a-form-item label="大分类" v-else>
                    <div style="display:flex;align-items:center">
                        <a-select v-decorator="['b_pids', { initialValue: formData.b_pids}]" class="mr10px" placeholder="请选择专业" :allowClear="true">
                            <a-select-option v-for="item in BpidList" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                        <a-icon type="plus-circle" class="csP fs18px" @click="showBpid = true"/>
                    </div>
                </a-form-item>
                <a-form-item label="专业" v-if="this.form.getFieldValue('b_pids') || this.form.getFieldValue('cate_id') == 41 || this.form.getFieldValue('cate_id') == 42">
                    <div style="display:flex;align-items:center">
                        <a-select v-decorator="['pids', { initialValue: formData.pids,rules: [{ required: true, message: '请选择专业' }]}]" class="mr10px" placeholder="请选择专业" :allowClear="true">
                            <a-select-option v-for="item in ProfessList" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                        <a-icon type="plus-circle" class="csP fs18px" @click="showP = true"/>
                    </div>
                </a-form-item>
                <a-form-item label="人数">
                    <a-radio-group v-model="user_type">
                        <a-radio :value="1"> 不限人数 </a-radio>
                        <a-radio :value="2"> 
                            额定人数
                            <a-input type="number" v-if="user_type == 2" v-decorator="['user_num', { initialValue: formData.user_num, rules: [{ required: true, message: '请填写额定人数' }] }]" :style="{ width: '100px', marginLeft: '10px' }" />
                        </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="添加科目">
                    <a-select
                        mode="multiple"
                        style="width: 100%"
                        :placeholder="!form.getFieldValue('cate_id')?'请先选择分类': '请选择科目'"
                        :disabled="!form.getFieldValue('cate_id')"
                        v-decorator="['sids', { initialValue: formData.sids, rules: [{ required: true, message: '请选择科目' }] }]"
                    >
                        <a-select-option v-for="i in subjectList" :key="i.id" :value="i.id">
                          {{i.name}}
                        </a-select-option>
                     </a-select>
                </a-form-item>
                <a-form-item label="上传详情页封面图">
                    <a-upload
                        name="avatar"
                        list-type="picture-card"
                        :show-upload-list="false"
                        :customRequest="customRequestDetailBg"
                        v-decorator="['detailfileImg',
                            { rules: [{ required: true, message: '请上传图片' }] },
                        ]"
                    >
                        <img v-if="detail_bg_url" :src="detail_bg_url" alt="avatar" />
                        <div v-else>
                            <a-icon :type="'plus'" style="font-size:30px;color:#dcdcdc"/>
                            <div>上传图片</div>
                        </div>
                    </a-upload>
                    <span>建议尺寸为750*320，大小不超过10M,格式为jpg</span>
                </a-form-item>
                <a-form-item label="详情页">
                    <div style="display:flex">
                        <div>
                            <a-radio-group v-model="detail_type">
                                <a-radio :value="1">通用</a-radio>
                                <a-radio :value="2"> 
                                    自定
                                    <!-- <a-input v-if="detail_type == 2" v-decorator="['detail_url', { initialValue: formData.detail_url, rules: [{ required: true, message: '请填写自定义' }] }]" :style="{ width: '200px', marginLeft: '10px' }" /> -->
                                </a-radio>
                            </a-radio-group>
                        </div>
                        <div>
                            <a-upload
                                v-if="detail_type == 2"
                                name="avatar"
                                list-type="picture-card"
                                :show-upload-list="false"
                                :customRequest="customRequestDetail"
                                v-decorator="['detailImg',
                                    { rules: [{ required: true, message: '请上传图片' }] },
                                ]"
                            >
                                <img v-if="detail_bg_url" :src="detail_bg_url" alt="avatar" />
                                <div v-else>
                                    <a-icon :type="loading ? 'loading' : 'plus'" style="font-size:30px;color:#dcdcdc"/>
                                    <div>上传图片</div>
                                </div>
                            </a-upload>
                        </div>
                    </div>
                </a-form-item>
                <a-form-item label="价格">
                     <div class="sTable">
                         <div class="th">
                            <div>原价</div>
                            <div>现价</div>
                         </div>
                         <div class="tbody">
                             <div class="taC">
                                <a-form-item>
                                    <a-input type="number" v-decorator="['old_price', { initialValue: formData.old_price, rules: [{ required: true, message: '请填写原价' }] }]" prefix="￥" suffix="元" style="width:160px"/>
                                </a-form-item>
                             </div>
                             <div class="taC">
                                <a-form-item>
                                    <a-input type="number" v-decorator="['now_price', { initialValue: formData.now_price, rules: [{ required: true, message: '请填写现价' }] }]"  prefix="￥" suffix="元" style="width:160px"/>
                                </a-form-item>
                             </div>
                         </div>
                     </div>
                </a-form-item>   
                <a-form-item label="考试时间">
                    <a-date-picker v-decorator="['exam_time', { initialValue: formData.exam_time,  rules: [{ required: true, message: '请选择考试时间' }] }]" />
                </a-form-item>
                <a-form-item label="有效时间">
                    <a-input v-decorator="['valid_time', { initialValue: formData.valid_time, rules: [{ required: true, message: '请填写有效时间' }] }]" style="width:160px;margin-right:10px"></a-input>年
                </a-form-item>   
           </a-form>
            <div style="text-align:right;padding-top:30px;padding-right:20%">
                <a-button class="mr20px" style="width:100px" @click="$emit('close')">取消</a-button>
                <a-button type="primary"  style="width:100px" @click="submit">立即添加</a-button>
            </div>
      </div>
    </a-drawer>
</template>
<script>
import { uploadImg } from '@/libs/api'
import * as http from '@/libs/examapi'
import { momentDay,formatDay, momentDays } from '@/libs/moment'
import addProfessional from './addProfessional'
import addSchool from './addSchool'
import addBpid from './addBpid'
export default {
    name: 'addClasses',
    components:{ addProfessional, addSchool, addBpid },
    props: ['visible', 'options', 'data', 'edit', 'allSubject'],
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    data(){
        return{
            formItemLayout: {
                labelCol: { span: 8 },
                wrapperCol: { span: 10 },
            },
            imageUrl: '',
            user_type: 1,
            detail_type: 1,
            showP:false,
            loading: false,
            subjectList: [],
            ProfessList:[],
            detailUrl:'',
            title:'添加课程包',
            showSchool: false,
            showBpid: false,
            SchoolList: [],
            BpidList: [], 
            detailfileImg:[],
            detail_bg_url:'',
            formData:{
                name:'',short_name:'',title:'',tag:'',cate_id:'',user_num:'',
                sids:[],detail_url:'',old_price:'',now_price:'',exam_time:null ,valid_time:'',
                pids: '', school: '', b_pids:''
            }
        }
    },
    watch:{
        visible(val){
            if(!val){
                this.reset()
            }else{
                this.init().then(()=>{
                    if(this.edit){
                        Object.assign(this.formData, this.data);
                        this.data.pids == 0? this.formData.pids = '' : this.formData.pids = this.data.pids
                        this.data.b_pids == 0? this.formData.b_pids = '' : this.formData.b_pids = this.data.b_pids
                        this.title = '编辑课程包'
                        this.imageUrl = this.data.img
                        this.detailUrl = this.data.detail_url
                        this.detail_bg_url = this.data.detail_bg_url
                        this.formData.exam_time = momentDays(this.data.exam_time*1000)
                        if(this.data.user_num >-1){
                            this.user_type = 2
                        }else{
                            this.user_type = 1
                        }
                        this.detail_type = this.data.detail_type
                        this.subjectList = this.allSubject.filter(el=>el.cate_id == this.data.cate_id)
                        this.formData.sids = this.data.sids.split(',').map(el=>Number(el))
                        setTimeout(()=>{
                            this.form.setFieldsValue({'fileImg':[{uid:-1, name: 'image.png',status: 'done', url: this.data.img}]})
                            this.form.setFieldsValue({'detailfileImg':[{uid:2, name: 'imageBg.png',status: 'done', url: this.data.detail_bg_url}]})
                            if(this.detail_type == 2){
                                this.form.setFieldsValue({'detailImg':[{uid:1, name: 'detailimage.png',status: 'done', url: this.data.detail_url}]})
                            }
                        })
                    }else{
                        this.title = '新增课程包'
                    }
                })
            }
        }
    },
    methods:{
        reset(){
            this.form.resetFields()
            this.imageUrl = ''
            this.detail_bg_url = ''
            this.user_type = 1
            this.detail_type = 1
            this.subjectList = []
            this.loading = false
            this.detailUrl = ''
            this.showP = false
            this.showSchool = false
            this.formData = {
                name:'',short_name:'',title:'',tag:'',cate_id:'',user_num:'',
                sids:[],detail_url:'',old_price:'',now_price:'',exam_time:null,valid_time:'',
                pids:'', school: '',b_pids:''
            }
        },
        init(){
            return new Promise((resolve,reject) => {
                Promise.all([this.GetSchool(), this.GetProfess(),this.GetBpid()]).then(res=>{
                    resolve()
                }).catch(reject)
            })
        },
        GetBpid(){
            http.getBPid().then(res=>{
                this.BpidList = res
            }).catch(error=>{
                console.log(error)
            })
        },
        GetSchool(){
             http.getSchool().then(res=>{
                this.SchoolList = res
            }).catch(error=>{
                console.log(error)
            })
        },
        GetProfess(){
            http.getProfessional().then(res=>{
                this.ProfessList = res
            }).catch(error=>{
                console.log(error)
            })
        },
        changeCate(){
            setTimeout(()=>{
                if(this.form.getFieldValue('sids')) this.form.setFieldsValue({'sids': []})
                this.subjectList = this.allSubject.filter(el=>el.cate_id == this.form.getFieldValue('cate_id'))
            })
        },
        customRequest(data){
            let formData = new FormData()
            formData.append('file',data.file)
            uploadImg(formData).then(res=>{
                if(res){
                    this.imageUrl=res.fileUrl
                }
            },error=>{
             console.log(error)
            })
        },
        customRequestDetail(data){
            let formData = new FormData()
            formData.append('file',data.file)
            uploadImg(formData).then(res=>{
                if(res){
                    this.detailUrl=res.fileUrl
                }
            },error=>{
             console.log(error)
            })

        },
        customRequestDetailBg(data){
            let formData = new FormData()
            formData.append('file',data.file)
            uploadImg(formData).then(res=>{
                if(res){
                    this.detail_bg_url=res.fileUrl
                }
            },error=>{
             console.log(error)
            })
        },
        closeProfess(){
            this.showP = false;
            this.GetProfess()
            this.form.setFieldsValue({'pids': ''})
        },
        closeSchool(){
            this.showSchool = false;
            this.form.setFieldsValue({'school': ''})
            this.GetSchool()
        },
        closeBpid(){
            this.showBpid = false;
            this.form.setFieldsValue({'b_pids': ''})
            this.GetBpid()
        },
        submit(){
            this.form.validateFields((err, values) => {
                if(err) return;
                let request = this._.cloneDeep(values)
                delete request.fileImg
                delete request.valid_time
                delete request.sids
                delete request.exam_time
                delete request.detailImg
                delete request.detailfileImg
                request.img = this.imageUrl
                request.detail_bg_url = this.detail_bg_url
                request.user_num = this.user_type==1 ? -1 : values.user_num
                request.detail_type = this.detail_type
                request.detail_url = this.detail_type==1 ? '' : this.detailUrl
                request.sids = values.sids.join(',')
                request.valid_time = values.valid_time
                request.exam_time = Math.floor(values.exam_time.valueOf()/1000) 
                if(!(request.cate_id == 41 || request.cate_id == 42 )){
                    request.school = ''
                }
                if(!request.b_pids){
                    request.pids = ''
                }
                if(this.edit){
                    request.id = this.data.id
                    http.edit_crouse_bag(request).then(res=>{
                        this.$emit('close')
                        this.$emit('update')
                    }).catch(error=>{
                        console.log(error)
                    })
                }else{
                    http.add_crouse_bag(request).then(res=>{
                        this.$emit('close')
                        this.$emit('update')
                    }).catch(error=>{
                        console.log(error)
                    })
                }
            })
        },
        vaildatorPrice(rule, value, callback){
        }
    }
}
</script>
<style lang="less" scoped>
.sTable{
    width: 420px;
    border: 1px solid #eee;
    .th{
        background: #eeeeee;
        height: 32px;
        display: flex;
        align-items: center;
        text-align: center;
        >div{
            flex: 1;
        }
    }
    .tbody{
        padding: 20px 10px;
        display: flex;
        align-items: center;
        >div{
            flex: 1;
        }
    }
}
</style>